import React, { useState } from "react";
import { IPetsyPetsyAnnualLimitBonusAppliedProps } from "./PetsyAnnualLimitBonusApplied.types";
import {
  useFlowData,
} from "@adaptis/flow-components";
import {
  Modal,
  Image,
} from "react-bootstrap";
import "./PetsyAnnualLimitBonusApplied.scss";
import _ from "lodash";

export default function PetsyAnnualLimitBonusApplied(props: IPetsyPetsyAnnualLimitBonusAppliedProps) {
  const { getData, setData, injectData } = useFlowData();
  const petType = getData("petType");
  const petAgeCategory = getData("petAgeCategory");

  function GetContent() {
    if (petAgeCategory < 3) {
      return (
        <>
          <div>
            <Image className="" src={`/images/annual-limit-${petType}-20-applied.png`} />
          </div>
          <div className="bonus-content mt-4">
            <div className="head">LITTLE PET, BIG PERK</div>
            <div className="title">20% Annual Limit Bonus Applied</div>
            <div className="decription">You’ve qualified for a 20% bonus on your chosen Annual Limit at no extra cost.</div>
          </div>
        </>
      )
    } else {
      return (
        <>
          <div>
            <Image className="" src={`/images/annual-limit-${petType}-10-applied.png`} />
          </div>
          <div className="bonus-content mt-4">
            <div className="head">LITTLE PET, BIG PERK</div>
            <div className="title mt-2">10% Annual Limit Bonus Applied</div>
            <div className="decription mt-2">You’ve qualified for a 10% bonus on your chosen Annual Limit at no extra cost.</div>
          </div>
        </>
      )
    }
  }

  if (petAgeCategory) {
    return (
      <div className="petsy-annual-limit-bonus mt-4 mb-0">
        {GetContent()}
      </div>
    );
  } else {
    return (<></>);
  }

}
